module.exports = __webpack_public_path__ + "static/media/4.9bf1f0ce.JPG";